import { UserState } from "../../models/UserState";

const forgotPasswordSuccess = (state: UserState) => {
    state.isLoading = false;
    state.isSendEmail = true;
    state.isError = null;
}

export default forgotPasswordSuccess;